import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";

import {DropdownIndicator, filterOption, listSelectStyles, optionWithMarker, RadioMarker, SingleValue} from "./listSelectParts";

/**
 * Compact (40px) select whose menu is a list of options with a radio on the
 * right, the chosen one ticked (DS "Form / Checkbox List" in a scrollable container).
 */
RadioListSelect.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        adornment: PropTypes.node,
    })).isRequired,
    value: PropTypes.string,
    placeholder: PropTypes.node,
    onChange: PropTypes.func.isRequired,
    highlighted: PropTypes.bool,
    disabled: PropTypes.bool,
    searchable: PropTypes.bool,
    noOptionsText: PropTypes.node,
};

const COMPONENTS = {Option: optionWithMarker(RadioMarker), SingleValue, DropdownIndicator, IndicatorSeparator: null};

function RadioListSelect({options, value, placeholder, onChange, highlighted = false, disabled = false, searchable = false, noOptionsText = null}) {
    const selected = options.find((option) => option.value === value) ?? null;
    const styles = useMemo(() => listSelectStyles(highlighted), [highlighted]);

    return (
        <Select
            options={options}
            value={selected}
            placeholder={placeholder}
            isDisabled={disabled}
            isSearchable={searchable}
            filterOption={filterOption}
            noOptionsMessage={() => noOptionsText}
            components={COMPONENTS}
            styles={styles}
            menuPortalTarget={document.body}
            menuShouldScrollIntoView={false}
            onChange={(option) => option && option.value !== value && onChange(option.value)}
        />
    );
}

export default RadioListSelect;
